import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "psp-tags-page__header-title" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "psp-tags-page" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "psp-tags-page__header" }, {
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_1, [
            (!_ctx.isOnlyOneWhitelabelAvailable)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.iconPageMultibrand,
                  class: "psp-tags-page__header-icon"
                }, null, 8 /* PROPS */, _hoisted_2))
              : _createCommentVNode("v-if", true),
            _cache[0] || (_cache[0] = _createTextVNode(" PSP tags ", -1 /* CACHED */))
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("pre", null, "      " + _toDisplayString(_ctx.pspTagList) + "\n    ", 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }))
}